/** Public error surface of the trading socket service; `requestId` correlates snackbars with logs. */
export class TradingSocketError extends Error {
    requestId: string;

    constructor(message: string, requestId: string) {
        super(message);
        this.name = 'TradingSocketError';
        this.requestId = requestId;
    }
}
